module.exports = __webpack_public_path__ + "img/icon-conf.edd3d7d5.svg";